import {
    ADAPTIVE_MODE,
    LS_MANUAL_ADAPTIVE_MODE,
} from '../constants';

export function getLsManualAdaptiveMode(): ADAPTIVE_MODE | null {
    const manualAdaptiveMode = localStorage.getItem(LS_MANUAL_ADAPTIVE_MODE);

    return Object.values(ADAPTIVE_MODE).includes(manualAdaptiveMode as ADAPTIVE_MODE) ?
        manualAdaptiveMode as ADAPTIVE_MODE :
        null;
}
